import airlineConfiguration from '../customer/airlineConfiguration.json';

export function getSettingsUri() {
    return `${airlineConfiguration.smartNotifyApiEndpoint}/api/MicrositeSettings/GetMicrositeSettings`;
}

export function getPassengerIdentificationUri({ surname, pnr }) {
    return `${airlineConfiguration.smartNotifyApiEndpoint}/api/Events/GetEncryptedString?surname=${surname}&pnr=${pnr}&origin=searchPage`;
}

export function getPassengersUri() {
    return `${airlineConfiguration.smartNotifyApiEndpoint}/api/Events/GetPassengerInformation`;
}

export function getReservationStatusUri(reservationId, lastName, arrivalDate) {
    if (arrivalDate) {
        return `${airlineConfiguration.smartNotifyApiEndpoint}/api/Reservations/GetReservationStatus?reservationId=${reservationId}&lastName=${lastName}&arrivalDate=${arrivalDate}`;
    }
    return `${airlineConfiguration.smartNotifyApiEndpoint}/api/Reservations/GetReservationStatus?reservationId=${reservationId}&lastName=${lastName}`;
}

export function getReservationToEnrollUri(
    reservationId,
    lastName,
    arrivalDate,
) {
    if (arrivalDate) {
        return `${airlineConfiguration.smartNotifyApiEndpoint}/api/Reservations/GetReservationToEnroll?reservationId=${reservationId}&lastName=${lastName}&arrivalDate=${arrivalDate}`;
    }
    return `${airlineConfiguration.smartNotifyApiEndpoint}/api/Reservations/GetReservationToEnroll?reservationId=${reservationId}&lastName=${lastName}`;
}

export function updateEnrollmentUri() {
    return `${airlineConfiguration.smartNotifyApiEndpoint}/api/Enrollments/UpdateEnrollment`;
}

export function cancelEnrollmentUri(reservationId, lastName) {
    return `${airlineConfiguration.smartNotifyApiEndpoint}/api/Enrollments/CancelEnrollment?reservationId=${reservationId}&lastName=${lastName}`;
}

export function getPassengerDataFromReservationIdUri(reservationId) {
    return `${airlineConfiguration.smartNotifyApiEndpoint}/api/Reservations/GetPassengerDataFromReservationId?reservationId=${reservationId}`;
}

export function getIsFlightValidUri(airline, flightNumber, flightArrivalDate) {
    return `${airlineConfiguration.smartNotifyApiEndpoint}/api/Flights/IsFlightValid?airline=${airline}&flightNumber=${flightNumber}&flightDate=${flightArrivalDate}`;
}

export function savePassengerFlightDataUri() {
    return `${airlineConfiguration.smartNotifyApiEndpoint}/api/Reservations/SaveFlightDataToReservation`;
}

export function getEnrollmentUri(reservationId, lastName) {
    return `${airlineConfiguration.smartNotifyApiEndpoint}/api/Enrollments/GetEnrollment?reservationId=${reservationId}&lastName=${lastName}`;
}

export function saveEnrollmentUri() {
    return `${airlineConfiguration.smartNotifyApiEndpoint}/api/Enrollments/SaveEnrollment`;
}

export function getBagEventsUri(reservationId) {
    return `${airlineConfiguration.smartNotifyApiEndpoint}/api/BagEvents/GetBagEvents?reservationId=${reservationId}`;
}

export function getEnrollmentRequestUri(enrollmentRequestId) {
    return `${airlineConfiguration.smartNotifyApiEndpoint}/api/EnrollmentRequests/GetEnrollmentRequest?enrollmentRequestId=${enrollmentRequestId}`;
}

export function openEnrollmentRequestUri() {
    return `${airlineConfiguration.smartNotifyApiEndpoint}/api/EnrollmentRequests/OpenEnrollmentRequest`;
}

export function updateEnrollmentRequestUri() {
    return `${airlineConfiguration.smartNotifyApiEndpoint}/api/EnrollmentRequests/UpdateEnrollmentRequest`;
}

export function closeEnrollmentRequestUri() {
    return `${airlineConfiguration.smartNotifyApiEndpoint}/api/EnrollmentRequests/CloseEnrollmentRequest`;
}

export function submitClaimUri() {
    return `${airlineConfiguration.smartNotifyApiEndpoint}/api/TracerRecord/CreateTracerRecord`;
}

export function saveNotificationSettingsUri() {
    return `${airlineConfiguration.smartNotifyApiEndpoint}/api/PassengerNotification/SavePassengerNotificationMethods`;
}

export function getClaimUri(claimNumber, lastName) {
    //THIS ONLY RETURNS ONE RESPONSE OBJECT>
    return `${airlineConfiguration.smartNotifyApiEndpoint}/api/TracerRecord/SearchTracerRecord?tracerReferenceNumber=${claimNumber}&lastName=${lastName}`;
}

export function submitUpdateClaimUri() {
    return `${airlineConfiguration.smartNotifyApiEndpoint}/api/TracerRecord/UpdateTracerRecord`;
}
